var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextUtil1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5797 62.9767C68.5797 93.5825 70.7939 118.393 73.5254 118.393C76.2568 118.393 78.471 93.5825 78.471 62.9767C78.471 32.3709 76.2568 7.56006 73.5254 7.56006C70.7939 7.56006 68.5797 32.3709 68.5797 62.9767ZM68.5797 62.9767C68.5797 93.5825 79.0832 118.393 92.0398 118.393C104.997 118.393 115.5 93.5825 115.5 62.9767C115.5 32.3709 104.997 7.56006 92.0398 7.56006C79.0832 7.56006 68.5797 32.3709 68.5797 62.9767ZM68.5797 62.9767C68.5797 93.5825 61.0286 118.393 51.7138 118.393C42.399 118.393 34.8478 93.5825 34.8478 62.9767C34.8478 32.3709 42.399 7.56006 51.7138 7.56006C61.0286 7.56006 68.5797 32.3709 68.5797 62.9767ZM68.5797 62.9767C68.5797 93.5825 55.5781 118.393 39.5399 118.393C23.5016 118.393 10.5 93.5825 10.5 62.9767C10.5 32.3709 23.5016 7.56006 39.5399 7.56006C55.5781 7.56006 68.5797 32.3709 68.5797 62.9767Z",
    stroke: "#EE7B07",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextUtil1);
export default __webpack_public_path__ + "static/media/text-util1.c68d17e4f134210746836cc34e03ae56.svg";
export { ForwardRef as ReactComponent };